import * as R from 'ramda'
import React from 'react'
import { LinkPrimary } from 'mage-deps/@klarna/bubble-ui'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import omitProps from '@hocs/omit-props'

const RouterLink = ({ history, children, to, onClick, ...props }) => {
  return (
    <LinkPrimary
      {...props}
      onClick={event => {
        if (onClick) {
          onClick()
        }
        event.preventDefault()
        history.push(to)
      }}
    >
      {children}
    </LinkPrimary>
  )
}

RouterLink.propTypes = {
  children: PropTypes.node,
  history: PropTypes.object,
  to: PropTypes.string,
  onClick: PropTypes.func
}

export default R.compose(
  withRouter,
  omitProps('staticContext')
)(RouterLink)

export {
  RouterLink
}
